<script>
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButton from '@/components/McButton'

export default {
  page: {
    title: 'Marketplace Product Detail',
  },

  components: {
    Layout,
    McButton,
    PageHeader,
  },

  computed: {
    externalLink() {
      // Mengambil parameter more_link dari URL
      return this.$route.query.externalLink
    },
    title() {
      // Mengambil parameter more_link dari URL
      return this.$route.query.productName
    },
  },

  methods: {
    handleBack() {
      this.$router.push({ name: 'Marketplace' })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" class="mc-page-three">
        <template #afterTitle>
          <McButton
            variant="secondary"
            :text="$t('global.back')"
            icon="icon-outline_arrow-left"
            @click="handleBack"
          />
        </template>
      </PageHeader>
    </div>
    <div class="mc-marketplace-product-detail__iframe-container">
      <iframe :title="title" :src="externalLink" style="border: none" />
    </div>
  </Layout>
</template>
